module.exports = __webpack_public_path__ + "img/img-onnuriorder-quit-01.2b69af53.png";